export default __webpack_public_path__ + "static/media/ubiwhere.10c271b0.svg";